<app-offcanvas-base
  [returnUrl]="conditionalReturnUrl()"
  [returnParams]="returnParams()">
  <ng-container title> Edit business details </ng-container>
  <ng-container body>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()">
        <app-form-field
          boFieldPath="name"
          label="Business name"
          labelClass="text-muted"></app-form-field>
        <app-form-field
          boFieldPath="vat_num"
          placeholder="Enter VAT number"
          label="VAT number"></app-form-field>
        <app-form-field
          boFieldPath="size"
          label="Business size"></app-form-field>
        <app-form-field
          boFieldPath="billing_address"
          [placeholder]="'Street Address\nSuburb\nCity\nProvince\nPostal Code'"
          [textArea]="{ rows: 6, cols: 0 }"></app-form-field>
        @if (isEditingAddress()) {
          <p class="small text-muted">
            Please note that any changes in your billing address will only reflect in your next invoice.
          </p>
        }
        <div class="row gy-3 offcanvas-buttons">
          <div class="col-12 col-sm-auto">
            <app-offcanvas-cancel-btn [returnUrl]="conditionalReturnUrl()"></app-offcanvas-cancel-btn>
          </div>
          <div class="col-12 col-sm-auto ms-sm-auto">
            <app-submit
              [busy]="busy"
              btnID="updateBusinessSubmitBtn"
              [icon]="false"
              label="Save"></app-submit>
          </div>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
